<template>
  <div class="main-body">
    <div class="header">商家订单</div>
    <div class="out">

      <div class="search2">

        <el-button plain type="success" @click="showMake" size="mini" style="margin-right: 5px;margin-left: 0px">生成记录</el-button>

        <el-button plain type="success" @click="onBatchExport" size="mini" style="margin-right: 5px;margin-left: 0px">导出Excel</el-button>
        <el-button plain type="success" @click="getRQCode" size="mini" style="margin-right: 5px;margin-left: 0px">导出Word</el-button>

        <div style="float: right">

          <el-select size="mini" v-model="serveCode" clearable placeholder="请选择服务人员"
                     style="width:150px;margin-right:5px">
            <el-option
                v-for="item in arr_serve"
                :key="item.serveCode"
                :label="item.name"
                :value="item.serveCode">
            </el-option>
          </el-select>

          <el-input size="mini" v-model="elderlyName" placeholder="选择老人" disabled style="width: 200px;margin-right: 5px;">
            <el-button size="mini" slot="append" icon="el-icon-search" @click="showElderly"></el-button>
            <el-button size="mini" slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-select v-model="status" placeholder="订单状态" style="width: 100px;margin-right: 5px;">
            <el-option
                v-for="item in status_arr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

<!--          <el-select v-model="elderlyType" placeholder="老人类型" style="width: 100px;margin-right: 5px;">-->
<!--            <el-option-->
<!--                v-for="item in elderlyType_arr"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
          <el-select v-model="isAudit" placeholder="审核状态" style="width: 100px;margin-right: 5px;">
            <el-option
                v-for="item in isAudit_arr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

          <el-date-picker style="margin-right: 5px;width:210px;" title="起止时间" size="mini"
                          v-model="startEndTime"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button size="mini" plain type="primary" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table"

                border style="width: 100%;">

        <el-table-column prop="serialNumber" label="订单流水号" width="130" fixed></el-table-column>
<!--        <el-table-column prop="businessName" label="商家" width="105"></el-table-column>-->
        <el-table-column prop="userName" label="老人姓名" width="85"></el-table-column>
        <el-table-column prop="serveName" label="服务人员" width="85"></el-table-column>

        <el-table-column prop="" label="服务项目" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsName}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="60" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.number}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="105" label="审核状态" >
          <template slot-scope="scope">
            <div v-if="scope.row.isAudit == 1 ">已审核</div>
            <div v-else>未审核</div>
          </template>
        </el-table-column>

<!--        <el-table-column width="105" label="付款类型" >-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.payType == 'wx' ">微信</div>-->
<!--            <div v-if="scope.row.payType == 'ali' ">支付宝</div>-->
<!--            <div v-if="scope.row.payType == 'yue' ">余额</div>-->
<!--            <div v-if="scope.row.payType == 'cash' ">现金</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column width="105" label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status =='10' ">待付款</div>
            <div v-if="scope.row.status =='11' ">待接单</div>
            <div v-if="scope.row.status =='12' ">待开始</div>
            <div v-if="scope.row.status =='13' ">待结束</div>
            <div v-if="scope.row.status =='14' ">待评价</div>
            <div v-if="scope.row.status =='15' ">已取消</div>
            <div v-if="scope.row.status =='16' ">已评价</div>
            <div v-if="scope.row.status =='17' ">已退单</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="审核状态">
          <template slot-scope="scope">
            <div v-if="scope.row.isAudit ==1 ">已审核</div>
            <div v-else>未审核</div>
          </template>
        </el-table-column>

<!--        <el-table-column prop="createTime" :formatter="timefilter" width="120" label="创建时间"></el-table-column>-->
<!--        <el-table-column prop="planTime" :formatter="timefilter" width="120" label="预约服务时间"></el-table-column>-->
        <el-table-column prop="startTime" :formatter="timefilter" width="120" label="开始服务时间"></el-table-column>
        <el-table-column prop="completeTime" :formatter="timefilter" min-width="120" label="完成服务时间"></el-table-column>

        <el-table-column prop="order.receiveAddress" label="服务地址" width="200"></el-table-column>

        <el-table-column fixed="right" label="操作" width="250" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showInfo(scope.row)">详情</el-button>
            <el-button type="text" v-if="scope.row.isDelete!=1" size="mini" @click="deleteOrder(scope.row)">删除</el-button>

            <el-button v-if="scope.row.status==14 || scope.row.status==16" type="text" size="mini"
                       @click="refund(scope.row)">退单</el-button>

            <el-button type="text" size="mini" @click="down(scope.row)">下载</el-button>

            <el-button type="text" v-if="scope.row.isAudit != 1" size="mini" @click="auditOrder(scope.row)">审核</el-button>

            <el-button type="text" size="mini" @click="viewVideo(scope.$index, scope.row)">视频通话</el-button>


          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="showModalInfo=false"></Info>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>


    <WriteElderly ref="myElderly" v-show="showModalElderly" v-on:closeElderly="closeElderly"
                  v-on:setElderly="setElderly"></WriteElderly>

    <Video ref="myVideo" v-show="showModalVideo" v-on:closeMe="showModalVideo=false"></Video>

    <WordRecord ref="myWordRecord" v-show="showModalWordRecord" v-on:closeMe="showModalWordRecord=false"></WordRecord>



  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Info from "./Info3";
//import WriteElderly from "@/views/Elderly/Comm/ElderlyGov"
import WriteElderly from "@/views/Elderly/Comm/ElderlyGovAll"
import Video from "@/views/Service/Gov/Video";
import WordRecord from "./WordRecord";

import table2excel from "js-table2excel";

export default {
  name: "Page",
  data() {
    return {

      showModal:false,
      showModalInfo:false,
      showModalVideo:false,

      showModalSelectServe: false,
      showModalElderly:false,
      showModalWordRecord:false,

      serveOrderPrice:0,

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,



      startEndTime:[],


      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,

      showSum:true,

      elderlyType:'',
      elderlyType_arr:[
        {label:'全部类型',value:-1},{label:'政府老人',value:1},{label:'社会老人',value:2}
      ],

      isAudit:'',
      isAudit_arr:[
        {label:'全部状态',value:-1},{label:'已审核',value:1},{label:'未审核',value:0}
      ],


      status:'',
      status_arr:[
        {label:'全部状态',value:-1},
        {label:'待付款',value:10},
        {label:'待接单',value:11},
        {label:'待服务',value:12},
        {label:'待结束',value:13},
        {label:'待评价',value:14},
        {label:'已取消',value:15},
        {label:'已评价',value:16},
        {label:'已退单',value:17}
      ],

      arr_business:[],
      businessCode:'',

      arr_serve:[],
      serveCode:'',

      userCode: '',
      elderlyName:'',

    }
  },
  components: {
    Info,WriteElderly,Video,WordRecord
  },
  created() {
    this.init();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {

      const now = new Date();
      const start = new Date(now - 1000 * 60 * 60 * 24 * 30);
      const end = new Date(now);
      this.startEndTime = [timefilters(start).substring(0,10), timefilters(end).substring(0,10)];

      this.getBusiness();
    },


    showInfo(row){
      this.showModalInfo = !this.showModalInfo;
      this.$refs.myInfo.init(row.orderBusinessCode);
    },

    getBusiness(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error === 0) {

          this.arr_business = [];
          let arr = response.data.data;
          for(let i=0;i<arr.length;i++){
            if(arr[i].businessType == 6){
              this.arr_business.push(arr[i]);
            }
          }

          if(this.arr_business.length>0){
            this.businessCode = this.arr_business[0].businessCode;
            this.getServe(this.businessCode);
            this.getList();
          }

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },
    getServe(businessCode){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Serve/ListServe",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          businessCode: businessCode,
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.arr_serve = response.data.data;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },

    showElderly(){
      this.showModalElderly = !this.showModalElderly;
      this.$refs.myElderly.init();
    },
    closeElderly:function(){
      this.showModalElderly = !this.showModalElderly;
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.elderlyName = row.name;
    },
    clearElderly:function (){
      this.userCode = '';
      this.elderlyName = '';
    },

    showMake(){
      this.showModalWordRecord = !this.showModalWordRecord;
      this.$refs.myWordRecord.init(this.businessCode);
    },



    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },
    getTimeCreate(row, column, cellValue){

      if (cellValue) {

        let c = timefilters(cellValue);
        let p = timefilters(row.planTime);

        let c2 = new Date(c);
        let p2 = new Date(p);


        if(c2>p2){

          let r = Math.random();

          const start = new Date(p2 - (1000 * 60 * 60 * 2*r));

          return timefilters(start);
        }
        return timefilters(cellValue)

      }
    },


    getSummaries(param) {

      //const { columns, data } = param;console.log(data);
      const { columns} = param;
      const sums = [];
      columns.forEach((column, index) => {

        if (index === 0) {
          sums[index] = '合计';
        }

        if (index == 7) {
          sums[index] = parseFloat(this.serveOrderPrice).toFixed(2);
        }


        // const values = data.map(item => Number(item[column.property]));
        // if (!values.every(value => isNaN(value))) {
        //     sums[index] = values.reduce((prev, curr) => {
        //         const value = Number(curr);
        //         if (!isNaN(value)) {
        //             return prev + curr;
        //         } else {
        //             return prev;
        //         }
        //     }, 0);
        //     sums[index] += ' 元';
        // } else {
        //     sums[index] = 'N/A';
        // }



      });

      return sums;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this
      this.loading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:this.currentPage,
        pageSize:this.pageSize,

        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],

        businessCode:this.businessCode,
        serveCode:this.serveCode,
        userCode:this.userCode,
        elderlyType:this.elderlyType==''?-1:this.elderlyType,
        isAudit:this.isAudit==''?-1:this.isAudit,
        status:this.status==''?-1:this.status,

      }

      this.$axios({
        method: 'post',
        //url: this.$shopUrl + "OrderBusinessGov/PageBusiness",
        url: this.$shopUrl + "OrderBusinessGov/PageBusiness2",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.serveOrderPrice=response.data.data.allPrice;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },



    refund(row){

      this.$confirm('确认退单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "OrderBusinessAdm/AdmRefund",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            orderBusinessCode:row.orderBusinessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '退单成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {

      });

    },

    deleteOrder(row){
      this.$confirm('是否删除此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "OrderBusiness/DeleteOrderBusiness",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            orderBusinessCode:row.orderBusinessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '删除成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });
    },

    auditOrder(row){

      this.$confirm('确认已审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "OrderBusiness/AuditOrderBusiness",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            orderBusinessCode:row.orderBusinessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '审核成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });

    },


    onBatchExport() {

      this.$confirm('确定导出Excel吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.showModal=true

        this.$axios({
          method: 'post',
          //url: this.$shopUrl+"OrderBusinessGov/PageBusinessMul",
          url: this.$shopUrl+"OrderBusinessGov/PageBusinessMul2",
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            staffCode: getStaffCode(),
            pageIndex:1,
            pageSize:9999,

            startTime:this.startEndTime[0],
            endTime:this.startEndTime[1],

            businessCode:this.businessCode,
            serveCode:this.serveCode,
            userCode:this.userCode,
            elderlyType:this.elderlyType==''?-1:this.elderlyType,
            isAudit:this.isAudit==''?-1:this.isAudit,
            status:this.status==''?-1:this.status,
          }
        }).then( (response)=> {
          this.showModal=false

          if(response.data.error == 0){
            let list = response.data.data.pageInfo.list;

            let dd = [];
            for(let i=0;i<list.length;i++){
              let obj = {};
              obj["sort"] = i+1;
              obj["serialNumber"] = list[i].serialNumber+'-';
              //obj["businessName"] = list[i].businessName;
              obj["userName"] = list[i].userName;
              obj["userPhone"] = list[i].elderly.phone;
              obj["userIdCard"] = list[i].elderly.idCard+"-";
              obj["userAddress"] = list[i].order.receiveAddress;
              obj["userAge"] = this.getAgeByIDCard('','',list[i].elderly.idCard);
              obj["userGender"] = this.getGender('','',list[i].elderly.idCard);

              obj["serveName"] = list[i].serve.name;
              obj["serveIdCard"] = list[i].serve.idCard+"-";


              let goodsDTO = list[i].listOrderGoodsDTO;
              let str = "";
              let str2 = "";
              let str3 = "";
              for(let j=0;j<goodsDTO.length;j++){
                //str += '<div>'+goodsDTO[j].goodsName+'</div>';
                str2 += '<div>'+goodsDTO[j].goodsPrice+'</div>';
                str3 += '<div>'+goodsDTO[j].number+'</div>';

                str += goodsDTO[j].goodsName+',';

              }

              obj["goodsName"] = str.substring(0,str.length-1);
              obj["goodsPrice"] = str2;
              obj["goodsNumber"] = str3;

              //obj["price"] = list[i].price;

              let orderType = "";
              if(list[i].orderType == 2){
                orderType = "单独服务";
              }
              if(list[i].orderType == 3){
                orderType = "合并服务";
              }
              //obj["orderType"] = orderType;

              let payType = "";
              if(list[i].payType == 'cash'){
                payType = "现金";
              }
              if(list[i].payType == 'yue'){
                payType = "余额";
              }
              if(list[i].payType == 'wx'){
                payType = "微信";
              }
              if(list[i].payType == 'ali'){
                payType = "支付宝";
              }
              //obj["payType"] = payType;

              let status = "";
              if(list[i].status == 10){
                status = "待付款";
              }
              if(list[i].status == 11){
                status = "待接单";
              }
              if(list[i].status == 12){
                status = "待服务";
              }
              if(list[i].status == 13){
                status = "待结束";
              }
              if(list[i].status == 14){
                status = "待评价";
              }
              if(list[i].status == 15){
                status = "已取消";
              }
              if(list[i].status == 16){
                status = "已评价";
              }
              if(list[i].status == 17){
                status = "已退单";
              }
              obj["status"] = status;


              //obj["createTime"] = timefilters(list[i].createTime);
              //obj["payTime"] = timefilters(list[i].payTime);
              //obj["planTime"] = timefilters(list[i].planTime);
              obj["completeTime"] = timefilters(list[i].completeTime);
              obj["startTime"] = timefilters(list[i].startTime);



              let start = list[i].orderServeRecordDTOStart;
              if(start != null){
                let arr_start = start.listOrderServeRecordImg;
                if(arr_start.length>0){
                  obj["start_img1"] = this.imgUrl+arr_start[0].imgPath+'_watermark.jpg';
                  obj["start_img2"] = '';
                }
                if(arr_start.length>1){
                  obj["start_img1"] = this.imgUrl+arr_start[0].imgPath+'_watermark.jpg';
                  obj["start_img2"] = this.imgUrl+arr_start[1].imgPath+'_watermark.jpg';
                }
              }else{
                obj["start_img1"] = '';
                obj["start_img2"] = '';
              }

              let end = list[i].orderServeRecordDTOEnd;
              if(end != null){
                let arr_end = end.listOrderServeRecordImg;
                if(arr_end.length>0){
                  obj["end_img1"] = this.imgUrl+arr_end[0].imgPath+'_watermark.jpg';
                  obj["end_img2"] = '';
                }
                if(arr_end.length>1){
                  obj["end_img1"] = this.imgUrl+arr_end[0].imgPath+'_watermark.jpg';
                  obj["end_img2"] = this.imgUrl+arr_end[1].imgPath+'_watermark.jpg';
                }
              }else{
                obj["end_img1"] = '';
                obj["end_img2"] = '';
              }


              dd.push(obj);
            }

            const column = [
              {
                title: '序号',
                key: 'sort',
                type: 'text'
              },
              // {
              //   title: '订单号',
              //   key: 'serialNumber',
              //   type: 'text'
              // },
              {
                title: '服务对象姓名',
                key: 'userName',
                type: 'text'
              },
              {
                title: '服务对象电话',
                key: 'userPhone',
                type: 'text'
              },
              {
                title: '服务对象身份证号',
                key: 'userIdCard',
                type: 'text'
              },
              {
                title: '服务对象地址',
                key: 'userAddress',
                type: 'text'
              },
              {
                title: '服务对象性别',
                key: 'userGender',
                type: 'text'
              },
              {
                title: '服务对象年龄',
                key: 'userAge',
                type: 'text'
              },
              {
                title: '服务人员姓名',
                key: 'serveName',
                type: 'text'
              },
              {
                title: '服务人员身份证号',
                key: 'serveIdCard',
                type: 'text'
              },
              {
                title: '服务项目',
                key: 'goodsName',
                type: 'text'
              },
              // {
              //   title: '单价',
              //   key: 'goodsPrice',
              //   type: 'text'
              // },
              // {
              //   title: '数量',
              //   key: 'goodsNumber',
              //   type: 'text'
              // },
              // {
              //   title: '总价',
              //   key: 'price',
              //   type: 'text'
              // },
              // {
              //   title: '订单类型',
              //   key: 'orderType',
              //   type: 'text'
              // },
              // {
              //   title: '支付类型',
              //   key: 'payType',
              //   type: 'text'
              // },
              {
                title: '订单状态',
                key: 'status',
                type: 'text'
              },

              // {
              //   title: '下单时间',
              //   key: 'createTime',
              //   type: 'text'
              // },
              // {
              //   title: '付款时间',
              //   key: 'payTime',
              //   type: 'text'
              // },
              {
                title: '时间开始服务开始时间',
                key: 'startTime',
                type: 'text'
              },
              {
                title: '时间结束服务完成时间',
                key: 'completeTime',
                type: 'text'
              },


              //图片高度超过20会出现异常
              // {
              //   title: '服务开始照片1',
              //   key: 'start_img1',
              //   type: 'image',
              //   width: 50,
              //   height: 20
              // },
              // {
              //   title: '服务开始照片2',
              //   key: 'start_img2',
              //   type: 'image',
              //   width: 50,
              //   height: 20
              // },
              // {
              //   title: '服务结束照片1',
              //   key: 'end_img1',
              //   type: 'image',
              //   width: 50,
              //   height: 20
              // },
              // {
              //   title: '服务结束照片2',
              //   key: 'end_img2',
              //   type: 'image',
              //   width: 50,
              //   height: 20
              // },


            ]
            table2excel(column, dd, '商家订单');

          }
        }).catch(function (error) {
          console.log(error);
        });



      }).catch(e => e)


    },


    down(row){
      this.showModal=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusinessGov/DownloadOrderWord",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          orderBusinessCode:row.orderBusinessCode,
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.showModal=false

          let path = response.data.data.path;
          window.open(this.$imgUrl+path,"_blank");

        } else if (response.data.error == 1) {
          this.$message({type: 'error', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    getRQCode() {

      this.$confirm('确定导出Word吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.showModal = true;

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "OrderBusinessGov/GetOrderWord",
          timeout: 1000*60*60*24,
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),

            pageIndex:1,
            pageSize:9999,

            startTime:this.startEndTime[0],
            endTime:this.startEndTime[1],

            businessCode:this.businessCode,
            serveCode:this.serveCode,
            userCode:this.userCode,
            elderlyType:this.elderlyType==''?-1:this.elderlyType,
            status:this.status==''?-1:this.status,
          }
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {

            this.showModal = false;
            window.location.href = this.$imgUrl + response.data.data;

          } else if (response.data.error == 1) {
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(e => e)


    },


    getAgeByIDCard(s,d,idCard) {
      try{
        const birthYear = idCard.substring(6, 10);
        const currentYear = new Date().getFullYear();
        const age = currentYear - parseInt(birthYear);
        return age;
      }catch (e){
        return '';
      }
    },
    getGender(s,d,idCard) {
      try{
        var reg = /^\d{17}(\d|x|X)$/;
        if (!reg.test(idCard)) {
          return "";
        }
        var genderDigit = parseInt(idCard.substr(16, 1));
        return genderDigit % 2 === 0 ? "女" : "男";
      }catch (e){
        return '';
      }
    },

    viewVideo(index, row){
      if(row.serve != null){
        this.$refs.myVideo.init({userCode:row.serve.userCode});
        this.showModalVideo = !this.showModalVideo;
      }

    },


  }
}
</script>


<style lang="scss" scoped>


</style>
